@use '@design/design-tokens/typography/typography' as *;

.zoomIntoViewText {
  position: absolute;
  color: var(--text-soft);
  transform: translate(-50%, -100%);
  @include typography-v2-body-sm;
}
